<template lang="">
  <div>
    <div class='topic-pc' v-if='!isMobile'>
      <my-header color='#333'></my-header>
      <div class='content'>
        <h1 class='topic-top'>{{ $t('topicAll.content1') }}</h1>
        <ul class='topic-ul'>
          <li class='topic-items' v-for="(items,index) in attentionList.slice(0,6)" :key='index'>
            <img :src="items.image_url + '_200x200'" alt="">
            <div class='topic-title'>
              <p>
                <a :href="'/topic/' + items.tag">#{{items.tag}}#</a>
              </p>
              <p>{{items.total_feeds}}{{ $t('topicAll.join') }}</p>
              <p>{{items.desc}}</p>
            </div>
          </li>
        </ul>
        <p class='topic-top'>{{ $t('topicAll.content2') }}</p>
        <ul class='topic-ul'>
          <li class='topic-items' v-for="(items,index) in attentionList" :key='index'>
            <img :src="items.image_url + '_200x200'" alt="">
            <div class='topic-title'>
              <p><a :href="'/topic/' + items.tag">#{{items.tag}}#</a></p>
              <p>{{items.total_feeds}}{{ $t('topicAll.join') }}</p>
              <p>{{items.desc}}</p>
            </div>
          </li>
        </ul>
      </div>
      <myFooter></myFooter>
    </div>
    <div class='mobile' v-else>
      <div class='mobile-div'>
        <h1 class='mobile-title'>{{ $t('topicAll.content1') }}</h1>
        <ul class='topic-box'>
          <li class='mobile-topic-items' v-for="(items,index) in attentionList.slice(0,5)" :key='index'>
            <img :src="items.image_url + '_200x200'" alt="">
            <div class='mobile-topic-txt'>
              <p><a :href="'/topic/'+ items.tag">#{{items.tag}}#</a></p>
              <p>{{items.total_feeds}}{{ $t('topicAll.join') }}</p>
              <p>{{items.desc}}</p>
            </div>
          </li>
        </ul>
        <h1 class='mobile-title'>{{ $t('topicAll.content2') }}</h1>
        <ul class='topic-box'>
          <li class='mobile-topic-items' v-for="(items,index) in attentionList" :key='index'>
            <img :src="items.image_url + '_200x200'" alt="">
            <div class='mobile-topic-txt'>
              <p><a :href="'/topic/'+ items.tag">#{{items.tag}}#</a></p>
              <p>{{items.total_feeds}}{{ $t('topicAll.join') }}</p>
              <p>{{items.desc}}</p>
            </div>
          </li>
        </ul>
      </div>

      <mobilefoot></mobilefoot>
      <my-menu color="#000"></my-menu>
    </div>
  </div>

</template>
<script>
  import Vue from "vue";
  import ajax from "Common/ajax";
  import constans from "Constans";
  import Utils from "Common/util";
  import cookie from "Common/cookie";
  import myHeader from 'Views/components/header'
  import myFooter from 'Views/components/foot'
  import mobilefoot from 'Views/components/mobilefoot'
  import myMenu from 'Views/components/menu'
  import VueMeta from 'vue-meta'
  import { Toast } from 'vant';
  Vue.use(Toast);
  Vue.use(VueMeta)
  const userUrl = constans.AllUrl.url.dev;
  export default {
    name: 'app',
    components: {
      myHeader,
      myFooter,
      mobilefoot,
      myMenu
    },
    data() {
      return {
        noattention: false,
        attentionList: [],
        canonicalUrl: '',
        title: '',
        desc: '',
        isMobile: true
      }
    },
    metaInfo() {
      return {
        title: this.title,
        meta: [
          {
            vmid: "description",
            name: "description",
            content: this.desc
          }
        ],
        link: [
          {
            ref: "canonical",
            href: this.canonicalUrl
          },
        ]
      }
    },
    created() {
      const that = this
      this.fetchData()
      let _arg = Utils.getQueryStringArgs();
      const language = cookie.getCookie('language')
      if (Utils.getLang() =='cn' || _arg.lang == 'zh-Hans-TW' || language == '简体中文') {
        that.canonicalUrl = 'https://www.lespark.cn/topic.html?lang=zh-Hant-TW'
        that.title = '话题互动 - LesPark'
        that.desc = 'LesPark集合了关于les交友、当下热点等女性用户感兴趣的话题，还有拉拉感兴趣的各种热门话题推荐，在此您可以与全球女性沟通互动。'
      } else if (Utils.getLang() =='en' || _arg.lang == 'en' || language == 'English') {
        that.canonicalUrl = 'https://www.lespark.cn/topic.html?lang=en'
        that.title = 'Lesbian community - Topic interaction - LesPark'
        that.desc = 'LesPark is a collection of popular topics of interest to lesbians, where you can interact with women from all over the world.'
      } else {
        that.canonicalUrl = 'https://www.lespark.cn/topic.html'
        that.title = '拉拉社區 - 話題互動 - LesPark'
        that.desc = 'LesPark集合了關於les交友、當下熱點等女性用戶感興趣的話題，還有拉拉感興趣的各種熱門話題推薦，在此您可以與全球女性溝通互動。'
      }
    },
    mounted() {
      const that = this
      that.changeType()
      window.addEventListener('resize', Utils.debounce(that.changeType, 1000))
    },
    methods: {
      goTopic(value) {
        window.location.href = '/topic/' + value
      },
      changeType() {
        const that = this
        if (document.documentElement.clientWidth < 960) {
          that.isMobile = true
        } else {
          that.isMobile = false
        }
      },
      fetchData() {
        ajax
          .Get({
            url:
              userUrl +
              "/v2/get_hot_tags?_t=" +
              new Date().getTime(),
            headers: {
              bundle_id: "pc",
              'bundle-id': 'pc',
              lang: "zh-hans",
              token: "",
              user_id: ''
            }
          })
          .then(ref => {
            let data = ref.data;
            this.attentionList = data.tags || [];
            if (this.attentionList.length == 0) {
              this.noattention = false;
            } else {
              this.noattention = true;
            }
          })
          .catch(ref => {
            console.log(ref);
          });
      },
    },
  }

</script>
<style lang="" scoped>
  [v-clock] {
    display: none;
  }

  .content {
    max-width: 1400px;
    min-width: 960px;
    width: 90%;
    position: relative;
    margin: 0 auto;
  }

  .topic-top {
    font-size: 38px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    letter-spacing: 1px;
    margin-bottom: 22px;
    text-align: left;
    width: 100%;
    margin-top: 20px;
  }

  .topic-ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
  }

  .topic-items {
    width: 442px;
    height: 136px;
    background: #F9F9F9;
    border-radius: 8px;
    display: flex;
    margin-bottom: 30px;
  }

  .topic-items>img {
    width: 136px;
    object-fit: cover;
    border-radius: 8px;
  }

  .topic-title {
    width: 251px;
    font-size: 18px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #555555;
    margin-left: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;

  }

  .topic-title>p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .topic-title a {
    color: #333333;
  }

  .topic-title>p:first-child {
    font-size: 20px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    color: #333333;
    letter-spacing: 1px;
  }

  .topic-title>p:nth-child(2) {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #666666;
    margin: 8px 0 25px;
  }

  /* 移动端 */
  .mobile {
    width: 100vw;
    box-sizing: border-box;
    position: relative;
  }

  .mobile-div {
    box-sizing: border-box;
    padding: 0 4vw;
  }

  .mobile-title {
    height: 12.8vw;
    text-align: left;
    width: 152px;
    line-height: 12.8vw;
    font-size: 5.0667vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  .topic-box {
    display: flex;
    flex-direction: column;
  }

  .mobile-topic-items {
    width: 100%;
    height: 28vw;
    background: #F9F9F9;
    border-radius: 1.0667vw;
    display: flex;
    margin-bottom: 2.6667vw;
  }

  .mobile-topic-items>img {
    width: 28vw;
    height: 28vw;
    object-fit: cover;
    border-radius: 1.0667vw;
  }

  .mobile-topic-txt {
    padding-left: 5.3333vw;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 4vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    letter-spacing: 1px;
    width: 54vw;
  }

  .mobile-topic-txt a {
    color: #333333;
  }

  .mobile-topic-txt>p {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mobile-topic-txt>p:nth-child(2) {
    margin: 2.6667vw 0 5.3333vw;
    font-size: 3.2vw;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    letter-spacing: 1px;
  }

  .mobile-topic-txt>p:last-child {
    font-size: 3.7333vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #555555;
    letter-spacing: 1px;

  }
</style>


// WEBPACK FOOTER //
// src/views/pages/topic-all/app.vue